<template>
  <div>
    <nav
      class="contextual-nav flex flex-wrap gap-x-2 gap-y-3 bg-white sm:gap-x-1 sm:gap-y-1"
      aria-label="Tabs"
    >
      <NuxtLink
        v-for="tab in tabs"
        :key="tab.name"
        :to="tab.href"
        :class="[
          { 'bg-p-500 text-grey-900': isActive(tab) },
          'text-nowrap rounded-md px-2.5 py-1 text-xs font-medium transition-colors duration-200',
        ]"
      >
        {{ tab.name }}
      </NuxtLink>
    </nav>
  </div>
</template>

<script setup lang="ts">
import type { TContextualTab } from '~/src/types/navigation'

defineProps<{
  tabs: TContextualTab[]
}>()

const route = useRoute()

const currentRoute = computed(() => route.path)

const isActive = (tab: TContextualTab) => {
  const currentRouteParts = currentRoute.value.split('/').filter(Boolean)
  const currentTabParts = tab.href.split('/').filter(Boolean)
  const section = currentRouteParts[1] || ''
  const tabSection = currentTabParts[1] || ''

  if (!section || !tabSection) return currentRoute.value === tab.href

  return section === tabSection || currentRoute.value === tab.href
}
</script>

<style>
.contextual-nav::before {
  content: '';
  position: absolute;
  width: 100%;
  left: 0;
  bottom: 100%;

  @apply h-main-content-pt bg-white;
}

.contextual-nav::after {
  content: '';
  position: absolute;
  width: 100%;
  left: 0;
  top: 100%;

  @apply h-contextual-nav-mb bg-white;
}
</style>
